import { makeColorSchema } from '../color-utils';
export const orangeStyle = makeColorSchema('#ef962e');
//# sourceMappingURL=orange.style.js.map